import * as React from 'react';

import StoreDefault from '@/assets/food/icons/storeDefault.svg?react';

import style from './StoreCard.module.scss';

interface ImageProps {
  images: string[];
}

const StoreImageDefault = () => (
  <div className={style.StoreImageDefaultContainer}>
    <StoreDefault />
  </div>
);

export default memo(function StoreImageFallback( {images}: ImageProps) {
  const [isError, setIsError] = React.useState(false);

  const isEmpty = images.length === 0;

  const renderContent = () => {
    if (isError || isEmpty) {
      return <StoreImageDefault />;
    }

    return images.map((item) => (
      <img
        key={`store-logo-${item}`}
        src={item}
        alt=""
        className={style.StoreImage}
        loading="lazy"
        onError={() => { setIsError(true); }}
      />
    ));
  };

  return <>{renderContent()}</>;
})